import React from 'react';
import { useTranslation } from 'react-i18next';
import { SnackbarAlert } from '@p81-common/ui';

interface PartialDataBannerProps {
  failedDrs: string[];
}

const PartialDataBanner = ({ failedDrs }: PartialDataBannerProps) => {
  const { t } = useTranslation('edges');

  if (!failedDrs.length) return null;

  return (
    <SnackbarAlert
      open={true}
      alertProps={{
        severity: 'warning'
      }}
    >
      {t('EDGES_LIST.PARTIAL_DATA_WARNING', { regions: failedDrs.join(', ') })}
    </SnackbarAlert>
  );
};

export default PartialDataBanner;
